module.exports = __webpack_public_path__ + "img/websiteNameLogoHeader.8e0aa1f1.jpg";